import { Component } from '@angular/core';

@Component({
  selector: 'app-rpt-tworoadspipelinebytag',
  templateUrl: './rpt-tworoadspipelinebytag.component.html',
  styleUrl: './rpt-tworoadspipelinebytag.component.css'
})
export class RptTworoadspipelinebytagComponent {

}
